import React from 'react';
import { Menu } from '@material-ui/core';
import { Button } from 'gd-react';
import './EditChoicePopover.scss';

class EditChoicePopover extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            anchorEl: null
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    handleClick(e) {
        this.setState({
            anchorEl: e.currentTarget
        });
    }

    handleClose() {
        this.setState({ anchorEl: null });
    }

    handleEditDefault = () => {
        this.props.onEditDefault(this.props.modifierKey);
        this.handleClose();
    }

    handleEditAsset = () => {
        this.props.onEditAsset(this.props.modifierKey);
        this.handleClose();
    }

    render() {
        const { anchorEl } = this.state;
        const { modifierName } = this.props;

        return (
            <div className="edit-choice-popover">
                <div onClick={this.handleClick}>
                    {this.props.children}
                </div>
                <Menu
                    id="edit-choice-popover"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={this.handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    disableEnforceFocus
                >
                    <div className="edit-choice-content">
                        <div className="choice-header">
                            Edit {modifierName}
                        </div>
                        <div className="choice-description">
                            How would you like to edit this modifier?
                        </div>
                        
                        <div className="choice-options">
                            <div className="choice-option" onClick={this.handleEditDefault}>
                                <div className="choice-icon">
                                    <i className="fas fa-globe"></i>
                                </div>
                                <div className="choice-content">
                                    <h4>Edit Global Default</h4>
                                    <p>Update the default for all assets of this type</p>
                                </div>
                            </div>
                            
                            <div className="choice-option" onClick={this.handleEditAsset}>
                                <div className="choice-icon">
                                    <i className="fas fa-cog"></i>
                                </div>
                                <div className="choice-content">
                                    <h4>Add Asset-Specific Rules</h4>
                                    <p>Create custom rules for this asset only</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Menu>
            </div>
        );
    }
}

export default EditChoicePopover;
